import { useEffect, useState } from 'react';
import { env } from '../../config/env';
import { connectRewardPartner } from '../../services/reward-partners/reward-partner-service';
import type { PreloadStatus } from '../../types/stateTypes';
import { encryptURL, getRSAPasswordPublicKey } from '../../utils/helper';
import ConnectionFail from './ConnectionFail';

const ConnectRewardPartner = () => {
  const [status, setStatus] = useState<PreloadStatus>('loading');
  const [completionURL, setCompletionURL] = useState<string>('');

  const [errorTitle, setErrorTitle] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [returnToAppTitle, setReturnToAppTitle] = useState<string>('');

  const defaultCompletionURL = `${env.VITE_DRIVER_PORTAL_URL}/reward-partner/connect?success=false`;

  useEffect(() => {
    connectRewardPartnerAccount();
  }, []);

  const connectRewardPartnerAccount = async () => {
    document.getElementById('loading')?.classList.add('manual-loading');

    try {
      const url = window.location.href;

      const rsaPublicKey = await getRSAPasswordPublicKey();
      const encryptedURL = await encryptURL(url, rsaPublicKey);

      const connectRewardPartnerRequest = {
        call_back_url: encryptedURL,
      };

      const response = await connectRewardPartner(connectRewardPartnerRequest);

      const completionURL = response.Data?.completion_url || defaultCompletionURL;
      setCompletionURL(completionURL);

      if (response.Data?.success) {
        window.location.href = completionURL;
        return;
      }

      setStatus('error');
      setErrorTitle(response.Data?.error_title || '');
      setErrorMessage(response.Data?.error_message || '');
      setReturnToAppTitle(response.Data?.return_to_app_title || '');
    } catch {
      setStatus('error');
      setCompletionURL(defaultCompletionURL);
    } finally {
      document.getElementById('loading')?.classList.remove('manual-loading');
    }
  };

  return (
    <>
      {status === 'error' && (
        <ConnectionFail
          completionURL={completionURL}
          errorTitle={errorTitle}
          errorMessage={errorMessage}
          returnToAppTitle={returnToAppTitle}
        />
      )}
    </>
  );
};

export default ConnectRewardPartner;
